import { render, staticRenderFns } from "./OrderSuccessBankTransfer.vue?vue&type=template&id=1b8aaf79&"
import script from "./OrderSuccessBankTransfer.vue?vue&type=script&lang=js&"
export * from "./OrderSuccessBankTransfer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports